import { Component, OnDestroy, OnInit } from '@angular/core'
import { SystemInfoModel } from '../../../../models/system-info.model'
import { Subscription } from 'rxjs'
import { SystemInfoService } from '../../../../services/admin/plant-setup/system-info.service'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
    selector: 'app-topbar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit, OnDestroy {
  private _systemInfo: SystemInfoModel = null
  private _subscription: Subscription

  public get systemInfo(): SystemInfoModel | null {
    return this._systemInfo
  }

  constructor(private systemInfoService: SystemInfoService) {}

  private getSystemInfo(): void {
    this.systemInfoService.getSystemInfo().subscribe({
      next: (response: SystemInfoModel): void => {
        this._systemInfo = SystemInfoModel.fromJson(response)
      },
      error: (error: HttpErrorResponse): void => {},
    })
  }

  private getSystemInfoAfterChangeEvent(): void {
    this._subscription = this.systemInfoService.changeEvent.subscribe((changed: boolean): void => {
      if (changed) {
        this.getSystemInfo()
      }
    })
  }

  private unsubscribeChangeEvent(): void {
    if (this._subscription) {
      this._subscription.unsubscribe()
    }
  }

  ngOnInit(): void {
    this.getSystemInfo()
    this.getSystemInfoAfterChangeEvent()
  }

  ngOnDestroy(): void {
    this.unsubscribeChangeEvent()
  }
}
